module.exports = __webpack_public_path__ + "static/media/GitIcon.bd96fa82.svg";